import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CapitalizePipe } from '../../../pipes/text-pipes';

@Component({
  selector: 'app-authentication-layout',
  standalone: true,
  imports: [RouterModule, TranslateModule, CapitalizePipe],
  templateUrl: './authentication-layout.component.html',
  styleUrl: './authentication-layout.component.scss',
})
export class AuthenticationLayoutComponent {
  title: string = '';
  description: string = '';
  routeTitleKey: string = 'login';

  constructor(private router: Router, private translate: TranslateService) {
  }

  private capitalize(text: string): string {
    return text.charAt(0).toUpperCase() + text.slice(1);
  }
}
